var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hc-no-data-box"},[_c('img',{attrs:{"width":"240","height":"165","src":_vm.quePngUrl}}),_c('div',{staticStyle:{"color":"#919499"}},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }